import type { MailboxInfo } from 'owa-client-types';
import type { TableView } from 'owa-mail-list-store';
import { tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault } from 'owa-mail-list-store';
import { type MenuItemType } from 'owa-filterable-menu/lib/components/MenuItemType';
import { getMailMenuItemShouldHideForMailbox } from '../actions/getMailMenuItemShouldHideForMailbox';

/**
 * Determines whether the Block/Never Block triage action is supported for the current selection.
 *
 * For a Unified Inbox selection the provided `mailboxInfo` is the virtual unified mailbox, so the
 * generic per-mailbox capability check is insufficient: we must resolve the real mailbox backing
 * the selected rows and validate that mailbox supports blocking. Block/Never Block is a
 * single-mailbox action today, so a selection spanning multiple mailboxes (or one that cannot be
 * resolved) is treated as unsupported. Third-party (shadow) mailboxes are excluded via the
 * underlying hide rule.
 *
 * For non Unified Inbox selections this defers to the standard per-mailbox capability check.
 */
export function isBlockSupportedForUnifiedInboxSelection(
    mailboxInfo: MailboxInfo,
    rowKeysOrIds: string[],
    tableView?: TableView
): boolean {
    try {
        const resolvedMailboxInfo = tryGetMailboxInfoFromRowKeysOrIdsIfUnifiedInboxOrDefault(
            mailboxInfo,
            rowKeysOrIds,
            tableView
        );
        return !getMailMenuItemShouldHideForMailbox(5, resolvedMailboxInfo);
    } catch {
        // The selection spans multiple mailboxes (or none could be resolved).
        return false;
    }
}
